module.exports = __webpack_public_path__ + "img/img41.0cfd5a89.png";